import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginCard } from "./Components/Card";
import { CreatedBy } from "./Components/CreatedBy";
import Loading from "./Components/Loading";

import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [error, setError] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { data } = await axios.post(
      process.env.NODE_ENV === "development" ? "http://localhost:3000/login" : `${process.env.REACT_APP_PROD_URL}/login`,
      { username: username, password: password },
      { withCredentials: true }
    );
    console.log("DEBUG LOGIN, axios answer :", data);
    if (data.isAuthenticated) {
      navigate("/");
    } else {
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    //IIFE (Immediately Invoked Function Expression) to check if the user is logged in and has a session.
    (async () => {
      try {
        const { data } = await axios.get(process.env.NODE_ENV === "development" ? "http://localhost:3000/check-session" : `${process.env.REACT_APP_PROD_URL}/check-session`, { withCredentials: true });
        console.log("Response.data : ", data);
        if (data.isAuthenticated) {
          navigate("/");
        } else {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.log(error);
        setIsLoggedIn(false);
      }
    })();
  }, [navigate]);

  return isLoggedIn === null ? (
    <Loading />
  ) : (
    <div className="grid h-screen md:place-items-center bg-gray-100 justify-center">
      <div className="container mx-auto pt-10 md:pt-0 bg-gray-100">
        <LoginCard
          cardTitle={"Login"}
          children={
            <form onSubmit={handleSubmit}>
              <div className="relative mb-4">
                <input
                  id="floating_outlined"
                  type="text"
                  name="Username"
                  className={
                    error
                      ? "block px-2.5 pb-2.5 pt-4 w-full text text-gray-900 bg-transparent rounded-lg border-2 border-red-500 appearance-none focus:outline-none focus:ring-0 focus:border-red-500 peer"
                      : "block px-2.5 pb-2.5 pt-4 w-full text text-gray-900 bg-transparent rounded-lg border-2 border-gray-200 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                  }
                  placeholder=" "
                  onChange={(e) => setusername(e.target.value)}
                />
                <label
                  htmlFor="floating_outlined"
                  className="absolute text-sm text-gray-500 duration-300 transform -translate-y-2 scale-75 top-2 z-10 origin-[0] bg-transparent px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-2 left-1"
                >
                  {"Username"}
                </label>
              </div>

              <div className="relative mb-4">
                <input
                  id="test"
                  type="password"
                  name="Password"
                  className={
                    error
                      ? "block px-2.5 pb-2.5 pt-4 w-full text text-gray-900 bg-transparent rounded-lg border-2 border-red-500 appearance-none focus:outline-none focus:ring-0 focus:border-red-500 peer"
                      : "block px-2.5 pb-2.5 pt-4 w-full text text-gray-900 bg-transparent rounded-lg border-2 border-gray-200 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                  }
                  placeholder=" "
                  onChange={(e) => setpassword(e.target.value)}
                />
                <label
                  htmlFor="test"
                  className="absolute text-sm text-gray-500 duration-300 transform -translate-y-2 scale-75 top-2 z-10 origin-[0] bg-transparent px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-2 left-1"
                >
                  Password
                </label>
              </div>

              <div>
                <button type="submit" value="Submit" className="bg-blue-600 rounded-lg text-white p-2 hover:bg-blue-500 w-full flex justify-center items-center">
                  <div>Submit</div>
                  {loading && (
                    <div role="status">
                      <svg aria-hidden="true" className="w-4 h-4 ml-2 text-gray-200 animate-spin fill-gray-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                      <span className="sr-only">Loading...</span>
                    </div>
                  )}
                </button>
              </div>
            </form>
          }
        ></LoginCard>
        {/* <CreatedBy /> */}
      </div>
    </div>
  );
};

export default Login;
